import { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const Policy = () => {
  const windowHeight = window.innerHeight;

  useEffect(() => {
    const reveal = (className) => {
      var reveals = document.querySelectorAll(className);

      for (var i = 0; i < reveals.length; i++) {
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    };

    window.addEventListener("scroll", () => {
      reveal(".reveal");
      reveal(".reveal2");
      reveal(".reveal3");
      reveal(".reveal4");
    });

    reveal(".reveal");
    reveal(".reveal2");
    reveal(".reveal3");
    reveal(".reveal4");

    return () => {
      window.removeEventListener("scroll", () => {
        reveal(".reveal");
        reveal(".reveal2");
        reveal(".reveal3");
        reveal(".reveal4");
      });
    };
  }, [windowHeight]);

  return (
    <>
      <Helmet>
        <title>Polityka prywatności | Anten-Sat</title>
        <meta
          name="description"
          content="Polityka prywatności ANTEN-SAT. Dowiedz się, jak chronimy Twoje dane osobowe."
        />
        <link rel="canonical" href="https://antensat.pl/policy" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Container fluid className="hero">
        <h1 className="reveal3 p-4">POLITYKA PRYWATNOŚCI</h1>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>INFORMACJE OGÓLNE:</h4>
          <p>
            {" "}
            Niniejsza polityka dotyczy Serwisu www, funkcjonującego pod adresem
            url: <Link to="https://antensat.pl/">https://antensat.pl/</Link>
            <br />
            <br />
            <ul>
              <li>
                Operatorem serwisu oraz Administratorem danych osobowych jest:
                <br /> <b>Jarosław Golanowski Stawowa 5, 42-274, Konopiska</b>
              </li>
              <li>
                Adres kontaktowy poczty elektronicznej operatora: <br />
                <b>antensat.kontakt@gmail.com</b>
              </li>
            </ul>{" "}
            Operator jest Administratorem Twoich danych osobowych w odniesieniu
            do danych podanych dobrowolnie w Serwisie. Serwis wykorzystuje dane
            osobowe w następujących celach: <br />
            <br />
            <ul>
              <li>Obsługa zapytań przez formularz</li>
              <li>Prezentacja oferty lub informacji</li>
            </ul>{" "}
            Serwis realizuje funkcje pozyskiwania informacji o użytkownikach i
            ich zachowaniu w następujący sposób: Poprzez dobrowolnie wprowadzone
            w formularzach dane, które zostają wprowadzone do systemów
            Operatora. Poprzez zapisywanie w urządzeniach końcowych plików
            cookie (tzw. „ciasteczka”).
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>WYBRANE METODY OCHRONY DANYCH STOSOWANE PRZEZ OPERATORA:</h4>
          <p>
            Miejsca logowania i wprowadzania danych osobowych są chronione w
            warstwie transmisji (certyfikat SSL). Dzięki temu dane osobowe,
            wprowadzone na stronie, zostają zaszyfrowane w komputerze
            użytkownika i mogą być odczytane jedynie na docelowym serwerze.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>HOSTING:</h4>
          <p>
            Serwis jest hostowany (technicznie utrzymywany) na serwerach
            operatora: dhosting.pl
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>INFORMACJE W FORMULARZACH:</h4>
          <p>
            Serwis zbiera informacje podane dobrowolnie przez użytkownika, w tym
            dane osobowe, o ile zostaną one podane. Dane podane w formularzu są
            przetwarzane w celu wynikającym z funkcji konkretnego formularza
            (kontaktu handlowego). Opis formularza w czytelny sposób informuje,
            do czego on służy.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>
            TWOJE PRAWA I DODATKOWE INFORMACJE O SPOSOBIE WYKORZYSTYWANIA
            DANYCH:{" "}
          </h4>
          <p>
            Twoje dane osobowe przetwarzane przez Administratora nie dłużej, niż
            jest to konieczne do wykonania związanych z nimi czynności
            Przysługuje Ci prawo żądania od Administratora:
            <ul>
              <li>dostępu do danych osobowych Ciebie dotyczących,</li>
              <li>ich sprostowania,</li>
              <li>usunięcia,</li>
              <li>ograniczenia przetwarzania,</li>
              <li>oraz przenoszenia danych</li>
            </ul>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>LOGI ADMINISTRATORA: </h4>
          <p>
            Informacje zachowaniu użytkowników w serwisie mogą podlegać
            logowaniu. Dane te są wykorzystywane w celu administrowania
            serwisem.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>INFORMACJE O PLIKACH COOKIES: </h4>
          <p>
            Serwis korzysta z plików cookies. Pliki cookies (tzw. „ciasteczka”)
            stanowią dane informatyczne, w szczególności pliki tekstowe, które
            przechowywane są w urządzeniu końcowym Użytkownika Serwisu i
            przeznaczone są do korzystania ze stron internetowych Serwisu.
            Cookies zazwyczaj zawierają nazwę strony internetowej, z której
            pochodzą, czas przechowywania ich na urządzeniu końcowym oraz
            unikalny numer. Podmiotem zamieszczającym na urządzeniu końcowym
            Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp
            jest operator Serwisu. Pliki cookies wykorzystywane są w
            następujących celach:{" "}
            <b>
              realizacji celów określonych w części "Istotne techniki
              marketingowe";
            </b>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>ISTOTNE TECHNIKI MARKETINGOWE: </h4>
          <p>
            Operator stosuje analizę statystyczną ruchu na stronie, poprzez
            Google Analytics (Google Inc. z siedzibą w USA). Operator nie
            przekazuje do operatora tej usługi danych osobowych, a jedynie
            zanonimizowane informacje. Usługa bazuje na wykorzystaniu ciasteczek
            w urządzeniu końcowym użytkownika. W zakresie informacji o
            preferencjach użytkownika gromadzonych przez sieć reklamową Google
            użytkownik może przeglądać i edytować informacje wynikające z plików
            cookies przy pomocy narzędzia:{" "}
            <Link to="https://www.google.com/ads/preferences/">
              preferences
            </Link>
          </p>
        </Row>

        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>ZARZĄDZANIE PLIKAMI COOKIES: </h4>
          <p>
            Jeśli użytkownik nie chce otrzymywać plików cookies, może zmienić
            ustawienia przeglądarki. Zastrzegamy, że wyłączenie obsługi plików
            cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa,
            utrzymania preferencji użytkownika może utrudnić, a w skrajnych
            przypadkach może uniemożliwić korzystanie ze stron www W celu
            zarządzania ustawienia cookies wybierz z listy poniżej przeglądarkę
            internetową, której używasz i postępuj zgodnie z instrukcjami:
            <ul>
              <li>
                <Link
                  to="https://support.microsoft.com/pl-pl/help/17442/windows-internet-explorer-delete-manage-cookies"
                  target="_blank"
                >
                  Internet Explorer
                </Link>
              </li>
              <li>
                <Link
                  to="https://support.microsoft.com/pl-pl/help/4027947/microsoft-edge-delete-cookies"
                  target="_blank"
                >
                  Microsoft Edge
                </Link>
              </li>
              <li>
                <Link
                  to="https://support.google.com/chrome/answer/95647?hl=pl"
                  target="_blank"
                >
                  Chrome
                </Link>
              </li>
              <li>
                <Link
                  to="https://support.mozilla.org/pl/kb/wzmocniona-ochrona-przed-sledzeniem-firefox-desktop?redirectslug=Włączanie+i+wyłączanie+obsługi+ciasteczek&redirectlocale=pl"
                  target="_blank"
                >
                  Firefox
                </Link>
              </li>
              <li>
                <Link
                  to="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac"
                  target="_blank"
                >
                  Safari
                </Link>
              </li>
              <li>
                <Link
                  to="https://help.opera.com/pl/latest/web-preferences/#cookies"
                  target="_blank"
                >
                  Opera
                </Link>
              </li>
            </ul>
            Urządzenia mobilne:
            <ul>
              <li>
                <Link
                  to="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=pl"
                  target="_blank"
                >
                  Android
                </Link>
              </li>
              <li>
                <Link
                  to="https://support.apple.com/pl-pl/HT201265"
                  target="_blank"
                >
                  iOS (Safari)
                </Link>
              </li>
              <li>
                <Link
                  to="https://support.microsoft.com/pl-pl/help/17442/windows-internet-explorer-delete-manage-cookies"
                  target="_blank"
                >
                  Windows Phone
                </Link>
              </li>
            </ul>
          </p>
        </Row>

        <hr className="custom-hr" />
        <Row className="p-4 reveal3 text-center">
          <h4>
            DZIĘKUJEMY ZA ZAPOZNANIE SIĘ Z NASZĄ POLITYKĄ PRYWATNOŚCI. ŻYCZYMY
            MIŁEGO KORZYSTANIA Z SERWISU.
          </h4>
        </Row>
        <hr className="custom-hr" />
      </Container>
    </>
  );
};

export default Policy;
